import { render, staticRenderFns } from "./DebtRuleDrawer.vue?vue&type=template&id=f67fe254&"
import script from "./DebtRuleDrawer.vue?vue&type=script&lang=ts&"
export * from "./DebtRuleDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./DebtRuleDrawer.vue?vue&type=style&index=0&id=f67fe254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports